import { useEffect, useState } from "react";
import api from "../../api/api";
import "./StreakSettingsModal.css";

function StreakSettingsModal({ onClose }) {
  const [streak, setStreak] = useState(null);
  const [newMinutes, setNewMinutes] = useState(30);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchStreak();
  }, []);

  const fetchStreak = async () => {
    try {
      const res = await api.get("/streak");
      setStreak(res.data);
      setNewMinutes(res.data.requiredMinutes);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const updateRequiredMinutes = async () => {
    if (newMinutes < 10) {
      setError("Minimum 10 minutes required.");
      return;
    }

    try {
      setUpdating(true);
      setError("");

      await api.post("/streak/update-required", {
        requiredMinutes: newMinutes,
      });

      await fetchStreak();
      setUpdating(false);
      onClose();
    } catch (err) {
      setUpdating(false);
      setError(
        err.response?.data?.message ||
          "Cannot update requirement yet."
      );
    }
  };

  if (loading || !streak) {
    return (
      <div className="streak-overlay">
        <div className="streak-modal">
          <div className="streak-header">
            <h2>🔥 Your Streak</h2>
            <button onClick={onClose}>✕</button>
          </div>

          <p style={{textAlign:"center", padding:"20px"}}>
            Your streak will start once you start your first lesson.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="streak-overlay">
      <div className="streak-modal">

        <div className="streak-header">
          <h2>🔥 Your Streak</h2>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="streak-stats">
          <div>
            <span>Current</span>
            <h3>{streak.currentStreak} days</h3>
          </div>

          <div>
            <span>Longest</span>
            <h3>{streak.longestStreak} days</h3>
          </div>

          <div>
            <span>Freeze</span>
            <h3>{streak.freezeCredits}</h3>
          </div>
        </div>

        <div className="today-progress">
          <span>Today's Progress</span>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${Math.min(
                  (streak.todayMinutes /
                    streak.requiredMinutes) *
                    100,
                  100
                )}%`,
              }}
            />
          </div>
          <p>
            {streak.todayMinutes} / {streak.requiredMinutes} mins
          </p>
        </div>

        <div className="streak-settings">
          <label>Daily Required Minutes</label>

          <input
            type="number"
            value={newMinutes}
            min={10}
            onChange={(e) =>
              setNewMinutes(Number(e.target.value))
            }
          />

          <button
            onClick={updateRequiredMinutes}
            disabled={updating}
          >
            {updating ? "Updating..." : "Update"}
          </button>

          {error && <p className="error">{error}</p>}
        </div>

      </div>
    </div>
  );
}

export default StreakSettingsModal;